import { useState, useEffect } from 'react';
import { getDocs, } from 'firebase/firestore';

export default function useCollectionsFetch (refs, dependencies = []) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if(!refs) return;

    (async () => {
      setItems(
        (await Promise.all(refs.map(getDocs)))
        .reduce((x, y) => [...x, ...y.docs], [])
        .map(_ => ({ id: _.id, ref: _.ref, ..._.data() }))
      );
    })();
  }, dependencies);
  return items;
};
